import styled from 'styled-components';

export const ViewContainer = styled.div`
    position: relative;
`;